import AutoCtaFunctionMixin from '@/mixins/RuleForm/Functions/AutoCta.js';
import MetaOdaxMixin from '@/mixins/RuleForm/Functions/MetaOdax.js';
import { BlockValidatableProvider } from '@/mixins/RuleForm/validatable.js';
import FormBlock from '@/ui/components/FormBlock.vue';

export default {
  mixins: [ MetaOdaxMixin, AutoCtaFunctionMixin, BlockValidatableProvider ],
  components: {
    FormBlock,
  },
  computed: {
    entity() {
      return this.$store.getters['ruleForm/entity'];
    },
  },
  methods: {
    validate() {
      if (!this.validateBlocks()) {
        return false;
      }

      return true;
    },
    validateBlocks() {
      return this.validateRegistered();
    },
  },
};
